import { LegalLayout, IssuerBlock, ProductOwnerNote, LiabilityText, useLegalInfo } from "@/components/LegalLayout";

export default function RefundPolicy() {
  const info = useLegalInfo();
  return (
    <LegalLayout title="Política de Devolução e Cancelamento" testid="refund-policy-page">
      <ProductOwnerNote info={info} />
      <p>Esta política aplica-se às subscrições da plataforma GestaCV (planos Essencial e Pro), pagas com Cartão Vinti4 / Visa / Mastercard / Amex, por cartão internacional (Stripe) ou por transferência bancária.</p>
      <h2>1. Natureza e entrega do serviço</h2>
      <p>O GestaCV é um serviço digital: o pagamento dá acesso à plataforma online, que é ativado logo após a confirmação do pagamento. Não há envio físico de bens nem custos de entrega. O preço é o mesmo em todos os meios de pagamento, sem taxas extra por pagar com cartão.</p>
      <h2>2. Reembolso total em 14 dias</h2>
      <p>Numa assinatura nova, pode pedir o reembolso total até 14 dias depois do primeiro pagamento.</p>
      <h2>3. Cancelamento depois dos 14 dias</h2>
      <ul>
        <li>Pode cancelar a assinatura a qualquer momento no painel (O meu plano).</li>
        <li>A assinatura deixa de renovar e o acesso mantém-se até ao fim do período já pago (mensal, 6 meses ou 12 meses).</li>
        <li>O período já pago não é reembolsado.</li>
        <li>Os dados da empresa continuam guardados.</li>
      </ul>
      <h2>4. Pagamentos em duplicado ou erros técnicos</h2>
      <p>Pagamentos em duplicado ou cobranças por erro técnico são sempre reembolsados na totalidade, em qualquer momento.</p>
      <h2>5. Como pedir</h2>
      <p>Envie um email para <a href={`mailto:${info.email}`} className="font-semibold text-petrol underline">{info.email}</a> com o nome da empresa e o número do Recibo ou a referência de pagamento (merchantRef, começa por “R”).</p>
      <h2>6. Prazos e forma de reembolso</h2>
      <ul>
        <li>Respondemos ao pedido em até 3 dias úteis.</li>
        <li>Os reembolsos aprovados são feitos pelo mesmo meio de pagamento (Vinti4, ou cartão via Stripe) em até 10 dias úteis.</li>
        <li>O momento em que o valor aparece na conta pode depender do banco emissor do cartão.</li>
      </ul>
      <h2>7. Limitação de responsabilidade</h2>
      <LiabilityText info={info} />
      <h2>8. Contacto</h2>
      <IssuerBlock info={info} />
    </LegalLayout>
  );
}
